import { makeStyles } from '@material-ui/core';

export const useCatalogCardIconStyles = makeStyles({
  card: {
    height: '100%',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  description: {
    minHeight: '3rem',
    marginBottom: '10px',
  },
  imageIcon: {
    maxWidth: '35px',
    maxHeight: '35px',
    borderRadius: '25%',
  },
  squareChip: {
    marginRight: '0',
    height: '26px',
  },
  chipContainer: {
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > :first-child': {
      borderBottomLeftRadius: '0.25em',
      borderTopLeftRadius: '.25em',
      borderBottomRightRadius: '0',
      borderTopRightRadius: '0',
    },
    '& > :nth-child(2)': {
      borderBottomLeftRadius: '0',
      borderTopLeftRadius: '0',
      borderBottomRightRadius: '0.25em',
      borderTopRightRadius: '.25em',
    },
  },
  avatar: {
    float: 'left',
    marginRight: '10px',
  },
  businessUnitChip: {
    marginTop: '5px',
    marginLeft: '5px',
  },
  namespace: {
    minHeight: '1rem',
    marginBottom: '0px',
  },
  namespaceLeft: {
    width: '30%',
    display: 'inline-block',
  },
  grid: {
    minHeight: '133px',
    marginTop: '10px',
  },
});
